export const Auth = {
    container: null
};
//# sourceMappingURL=helpers.js.map